export class Loader {
  constructor({ node, app }) {
    this.app = app;
    this.node = node;
    this.store = app.store;
    this.hideClassName = this.node.dataset.hideClass;
  }

  hide() {
    this.node.classList.add(this.hideClassName);
  }

  show() {
    this.node.classList.remove(this.hideClassName);
  }

  render() {
    if (this.app.getState('isFetching')) {
      this.show();
    } else {
      this.hide();
    }
  }
}
